module.exports = __webpack_public_path__ + "static/media/mltf-risk-assessment.ec1ccb21.pdf";